var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.4 33.7c.4-.4 1-.7 1.7-.7h19.3c.5 0 .9-.4.9-.9V8.6c0-.5-.4-.9-.9-.9H5.6c-.5 0-.9.4-.9.9v23.6c0 .5.4.9.9.9h9.9c1.3 0 2.4 1.1 2.4 2.4v1.8zm-4.2 10.9c-1.5 1.5-4 .4-4-1.7v-5.2H5.7c-3.1 0-5.6-2.5-5.6-5.6V8.6C.1 5.5 2.6 3 5.7 3h36.8c3.1 0 5.6 2.5 5.6 5.6v23.6c0 3.1-2.5 5.6-5.6 5.6H24z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0OCA0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibTI3LjQgNDIuN2MuNC0uNCAxLS43IDEuNy0uN2gxOS4zYy41IDAgLjktLjQuOS0uOXYtMjMuNWMwLS41LS40LS45LS45LS45aC0zNi44Yy0uNSAwLS45LjQtLjkuOXYyMy42YzAgLjUuNC45LjkuOWg5LjljMS4zIDAgMi40IDEuMSAyLjQgMi40djEuOHptLTQuMiAxMC45Yy0xLjUgMS41LTQgLjQtNC0xLjd2LTUuMmgtNy41Yy0zLjEgMC01LjYtMi41LTUuNi01LjZ2LTIzLjVjMC0zLjEgMi41LTUuNiA1LjYtNS42aDM2LjhjMy4xIDAgNS42IDIuNSA1LjYgNS42djIzLjZjMCAzLjEtMi41IDUuNi01LjYgNS42aC0xOC41eiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02IC05KSIvPjwvc3ZnPgo=";
export { SvgComment as ReactComponent };